'use client';

import { memo as Memo, useState, useRef, useEffect } from 'react';

//* HOC's
import withUIContext from '@/context/consumerHOC/UIConsumer';

//* Components
import Page from '@components/global/Page';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/pages/Contact/PageTopSection';
import BusinessCard from './_components/BusinessCard';
import ContactsLink from './_components/ContactsLink';

const Contact = Memo(({ pageData, globalData }) => {
    //! States
    const [state, setState] = useState(false);

    //! Refs
    const ref = useRef();

    const sectionAnimation = () => {
        if (ref.current) {
            const pointStart = window.innerHeight / 1.5;

            if (ref?.current?.getBoundingClientRect().top < pointStart) {
                setState(true);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', sectionAnimation);

        return () => {
            window.removeEventListener('scroll', sectionAnimation);
        };
    }, [state]);

    return (
        <Page>
            <HTMLContainer>
                <div className='section-item'>
                    <PageTopSection
                        type={1}
                        className={'contactTop'}
                        pageTop={{
                            title: pageData.title,
                            description: pageData.description,
                        }}
                    />
                </div>

                <div className='section-item'>
                    <BusinessCard businessCard={globalData.contact_information} />
                </div>

                <div
                    ref={ref}
                    className='section-item'>
                    <ContactsLink animate={state} />
                </div>
            </HTMLContainer>
        </Page>
    );
});

export default withUIContext(Contact, ['globalData']);
